module.exports = __webpack_public_path__ + "930713cbb68525be197d1ab369ab38a5.pdf";